import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { TextbausteineSlice } from "./types";

const initialState: TextbausteineSlice = {
	showAllKategorie: {}
};

export const {
	name: textbausteineSliceName,
	actions: { setFilterByKategorie },
	reducer: textbausteineReducer
} = createSlice({
	name: "textbausteine",
	initialState,
	reducers: {
		setFilterByKategorie(
			state: TextbausteineSlice,
			action: PayloadAction<{ activityId: string; showAllKategorie: boolean }>
		) {
			state.showAllKategorie[action.payload.activityId] = action.payload.showAllKategorie;
		}
	},
	extraReducers: builder => {
		builder.addMatcher(ActivityActions.cancel.match, (state, action) => {
			delete state.showAllKategorie[action.payload.activityId];
		});
	}
});
